import React from 'react';
import { useFormikContext } from 'formik';
import { UUID } from '../../../../../../types/shared/UUID';
import { eDepositorType } from '../../../../../../types/order/emdAccess/eDepositorType';
import { useGetDepositorOptions } from './hooks/useGetDepositorOptions';
import { SelectFieldTW } from '../../../../../../tailwindComponents/selectTW/SelectFieldTW';
import { SelectOption } from '../../../../../../tailwindComponents/selectTW/interfaces';
import { Show } from '../../../../../shared/Show';
import { ErrorMessageTW } from '../../../../../../tailwindComponents/errorMessage/ErrorMessageTW';

export const RecipientSelect: React.FC = () => {
  const { setFieldValue } = useFormikContext<{ orderId: UUID; depositorId: UUID; depositorType: eDepositorType }>();
  const { depositorOptions, depositorTypesDictionary } = useGetDepositorOptions();

  return (
    <div className={'flex flex-col gap-4'}>
      <Show when={depositorOptions.length === 0}>
        <ErrorMessageTW data-test-id={'no-depositors-message'}>
          <p>This order lacks a valid associated depositor for Acorn access.</p>
          <p>At least one buyer, borrower, or signatory must exist.</p>
          <p>That buyer, borrower, or signatory must have a valid email address.</p>
        </ErrorMessageTW>
      </Show>
      <SelectFieldTW
        labelText={'Recipient'}
        name={'depositorId'}
        options={depositorOptions}
        placeholder={'Select a Recipient'}
        isRequired
        onChange={(option: SelectOption) => {
          setFieldValue('depositorType', depositorTypesDictionary.get(`${option.value}`) ?? eDepositorType.Person);
          setFieldValue('depositorId', option.value);
        }}
      />
    </div>
  );
};
